import React, { useEffect } from 'react'
import { useIsAuthenticated } from '@azure/msal-react'
import { Navigate, useLocation } from 'react-router-dom'
import toast from 'react-hot-toast'

const PrivateRoute = ({ children }) => {
  const isAuth = useIsAuthenticated()
  const location = useLocation()

  useEffect(() => {
    if (!isAuth) {
      toast.error('Must be logged in to proceed.')
    }
  }, [isAuth])

  return isAuth ? (
    children
  ) : (
    <Navigate to='/' state={{ from: location }} replace />
  )
}

export default PrivateRoute
